import React from "react";

const VerticalDivider = () => <div id="vertical-divider" />;

export default VerticalDivider;
